import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, normalizeStyle as _normalizeStyle, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, Teleport as _Teleport, createBlock as _createBlock, withModifiers as _withModifiers, vModelText as _vModelText, withDirectives as _withDirectives, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = ["title"]
const _hoisted_2 = {
  key: 0,
  class: "ach-strip-badge"
}
const _hoisted_3 = { class: "ach-av-list-wrap" }
const _hoisted_4 = ["onClick", "onMouseenter"]
const _hoisted_5 = ["src", "alt"]
const _hoisted_6 = { key: 1 }
const _hoisted_7 = {
  key: 0,
  class: "ach-av-unread"
}
const _hoisted_8 = {
  key: 0,
  class: "ach-strip-empty"
}
const _hoisted_9 = { class: "ach-ttc-head" }
const _hoisted_10 = ["src", "alt"]
const _hoisted_11 = { key: 1 }
const _hoisted_12 = { class: "ach-ttc-headinfo" }
const _hoisted_13 = { class: "ach-ttc-row1" }
const _hoisted_14 = { class: "ach-ttc-name" }
const _hoisted_15 = {
  key: 0,
  class: "ach-ttc-unread"
}
const _hoisted_16 = {
  key: 0,
  class: "ach-ttc-email"
}
const _hoisted_17 = { class: "ach-ttc-body" }
const _hoisted_18 = { class: "ach-ttc-status" }
const _hoisted_19 = {
  key: 0,
  class: "ach-ttc-atend"
}
const _hoisted_20 = {
  key: 1,
  class: "ach-ttc-free"
}
const _hoisted_21 = {
  key: 0,
  class: "ach-strip-footer-badge"
}
const _hoisted_22 = { class: "ach-head" }
const _hoisted_23 = {
  key: 0,
  class: "ach-search"
}
const _hoisted_24 = {
  key: 1,
  class: "ach-empty"
}
const _hoisted_25 = {
  key: 2,
  class: "ach-empty"
}
const _hoisted_26 = {
  key: 3,
  class: "ach-empty"
}
const _hoisted_27 = {
  key: 4,
  class: "ach-list"
}
const _hoisted_28 = ["onClick"]
const _hoisted_29 = { class: "ach-item-av-wrap" }
const _hoisted_30 = ["src", "alt"]
const _hoisted_31 = { key: 1 }
const _hoisted_32 = { class: "ach-item-body" }
const _hoisted_33 = { class: "ach-item-name" }
const _hoisted_34 = { class: "ach-item-status" }
const _hoisted_35 = {
  key: 0,
  class: "ach-item-unread"
}
const _hoisted_36 = { class: "ach-head" }
const _hoisted_37 = {
  key: 0,
  class: "ach-chat-hinfo"
}
const _hoisted_38 = ["src", "alt"]
const _hoisted_39 = { key: 1 }
const _hoisted_40 = { class: "ach-chat-hname-wrap" }
const _hoisted_41 = { class: "ach-chat-hname" }
const _hoisted_42 = { class: "ach-chat-hstatus" }
const _hoisted_43 = {
  key: 0,
  class: "ach-empty"
}
const _hoisted_44 = {
  key: 0,
  class: "ach-empty"
}
const _hoisted_45 = { class: "ach-bubble" }
const _hoisted_46 = { class: "ach-bubble-text" }
const _hoisted_47 = { class: "ach-bubble-ts" }
const _hoisted_48 = {
  key: 0,
  class: "ach-error"
}
const _hoisted_49 = ["disabled"]
const _hoisted_50 = ["disabled"]

import { ref, computed, watch, nextTick, onMounted, onUnmounted } from 'vue'
import { useStore } from 'vuex'
import { useAgentChat } from '@/composables/useAgentChat'
import { useChatRailMode } from '@/composables/useChatRailMode'
import { usePermission } from '@/composables/usePermission'
import { avatarColor, initials } from '@/composables/useHelpers'
import { AVAIL_OPTIONS } from '@/composables/useAvailability'
import { useConversationStore } from '@/composables/useConversationStore'
import type { ChatAgent } from '@/types/agentChat'

const STRIP_W = 60

/* ── Scroll da lista de avatares (setas) ──────────────────────────
   A lista já era scrollável (overflow-y: auto), só não tinha nenhum indício
   visual disso — com mais agentes do que cabem no trilho, dava pra achar que
   só os visíveis existiam. */
const MIN_W = 260
const MAX_W = 640

export default /*@__PURE__*/_defineComponent({
  __name: 'AgentChatDrawer',
  setup(__props) {

const store    = useStore()
const authUser = computed(() => store.getters.authUser)
const myId     = computed(() => authUser.value?.id ?? 0)

// Mesma fonte que o Dashboard/AgentsTab usam pra "em atendimento" — estado de
// módulo já mantido por useDashboardEngine.loadData(), sem fetch próprio aqui.
const { conversations } = useConversationStore()
function openCountFor(agentId: number): number {
  return conversations.value.filter(c => c.assignee?.id === agentId && c.status === 'open').length
}

const {
  agents, unreadByAgent, totalUnread, activeAgentId, activeAgent, activeMessages,
  panelOpen, loadingAgents, loadingMessages, sendError,
  loadAgents, loadUnread, openThread, backToList, togglePanel, closePanel, send,
  startPolling, stopPolling,
} = useAgentChat()

const { mode: railMode, toggle: toggleRailMode } = useChatRailMode()
const { can } = usePermission()
const canUseAgentChat = computed(() => can('agentChat.view'))

const draft      = ref('')
const sending    = ref(false)
const msgListEl  = ref<HTMLElement | null>(null)

// Busca/filtro por nome ou e-mail na lista de agentes do painel
const agentSearch = ref('')
const filteredAgents = computed(() => {
  const q = agentSearch.value.trim().toLowerCase()
  if (!q) return agents.value
  return agents.value.filter(a => a.name.toLowerCase().includes(q) || a.email.toLowerCase().includes(q))
})
watch(panelOpen, open => { if (!open) agentSearch.value = '' })

// Largura fixa do trilho (.ach-strip) — usado pra posicionar o card de hover
// (ach-tt-card) encostado nele, mesmo cálculo do STRIP_W em ConvDrawer.vue.
const avListEl     = ref<HTMLElement | null>(null)
const canScrollUp   = ref(false)
const canScrollDown = ref(false)

function updateScrollState() {
  const el = avListEl.value
  if (!el) { canScrollUp.value = false; canScrollDown.value = false; return }
  canScrollUp.value   = el.scrollTop > 4
  canScrollDown.value = el.scrollTop + el.clientHeight < el.scrollHeight - 4
}

function scrollList(dir: 1 | -1) {
  avListEl.value?.scrollBy({ top: dir * 120, behavior: 'smooth' })
}

watch(agents, () => nextTick(updateScrollState), { flush: 'post' })

// Reavalia quando o container muda de altura (resize da janela, DevTools
// abrindo/fechando, zoom) — sem isso, canScrollUp/Down ficava travado no
// valor calculado só na última vez que `agents` mudou ou a lista rolou.
let avListResizeObserver: ResizeObserver | null = null
watch(avListEl, el => {
  avListResizeObserver?.disconnect()
  avListResizeObserver = null
  if (!el) return
  avListResizeObserver = new ResizeObserver(() => updateScrollState())
  avListResizeObserver.observe(el)
  nextTick(updateScrollState)
})

onMounted(() => nextTick(updateScrollState))
onUnmounted(() => avListResizeObserver?.disconnect())

/* ── Card com dados do agente ao passar o mouse (mesmo padrão do
   cdr-tt-pill/showTT de ConvDrawer.vue, aplicado aqui aos agentes) ── */
const ttAgent = ref<{ agent: ChatAgent; y: number } | null>(null)

function showAgentTT(agent: ChatAgent, e: MouseEvent) {
  const rect = (e.currentTarget as HTMLElement).getBoundingClientRect()
  ttAgent.value = { agent, y: Math.round(rect.top + rect.height / 2) }
}
function hideAgentTT() { ttAgent.value = null }

function statusColor(av: string): string {
  return AVAIL_OPTIONS.find(o => o.value === av)?.color ?? '#9ca3af'
}
function statusLabel(av: string): string {
  return AVAIL_OPTIONS.find(o => o.value === av)?.label ?? 'Offline'
}

function fmtTs(ts: number): string {
  const d = new Date(ts * 1000)
  return `${d.toLocaleDateString('pt-BR', { day: '2-digit', month: '2-digit' })} ${d.toLocaleTimeString('pt-BR', { hour: '2-digit', minute: '2-digit' })}`
}

function scrollToBottom() {
  nextTick(() => {
    if (msgListEl.value) msgListEl.value.scrollTop = msgListEl.value.scrollHeight
  })
}

/* ── Resize — mesmo mecanismo do ConvDrawer (cdr_panel_w), chave própria ── */
const panelWidth = ref(Math.max(MIN_W, Math.min(MAX_W, parseInt(localStorage.getItem('ach_panel_w') || '320'))))

let _rx = false, _sx = 0, _sw = 0

function startResize(e: MouseEvent) {
  _rx = true; _sx = e.clientX; _sw = panelWidth.value
  document.addEventListener('mousemove', doResize)
  document.addEventListener('mouseup', stopResize)
  document.body.style.userSelect = 'none'
  document.body.style.cursor = 'col-resize'
}
function doResize(e: MouseEvent) {
  if (!_rx) return
  panelWidth.value = Math.max(MIN_W, Math.min(MAX_W, _sw + (_sx - e.clientX)))
}
function stopResize() {
  _rx = false
  document.removeEventListener('mousemove', doResize)
  document.removeEventListener('mouseup', stopResize)
  document.body.style.userSelect = ''
  document.body.style.cursor = ''
  localStorage.setItem('ach_panel_w', String(panelWidth.value))
}

async function openAgent(id: number) {
  panelOpen.value = true
  await openThread(myId.value, id)
  scrollToBottom()
}

async function onSend() {
  const text = draft.value
  if (!text.trim() || activeAgentId.value == null) return
  draft.value = ''
  sending.value = true
  await send(myId.value, activeAgentId.value, text)
  sending.value = false
  scrollToBottom()
}

watch(activeMessages, scrollToBottom)

// Carrega agentes/não-lidas e arma o polling assim que o token E a permissão
// (agentChat.view) estiverem disponíveis — cobre o mount inicial e também o
// caso do useAdmin ainda estar carregando os perfis nesse instante (a
// permissão libera um instante depois do token, não junto).
watch(
  () => [authUser.value?.access_token, canUseAgentChat.value] as const,
  ([token, allowed]) => {
    if (!token || !allowed) {
      if (!allowed) stopPolling()
      return
    }
    loadAgents(token, myId.value)
    loadUnread(myId.value)
    startPolling(token, myId.value)
  },
  { immediate: true },
)

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_unref(railMode) === 'agent' && canUseAgentChat.value)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: _normalizeClass(["ach-strip", { 'is-expanded': _unref(panelOpen) }])
        }, [
          _cache[21] || (_cache[21] = _createElementVNode("div", { class: "ach-strip-cap" }, null, -1)),
          _createElementVNode("div", {
            class: "ach-strip-head",
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_unref(togglePanel) && _unref(togglePanel)(...args))),
            title: _unref(panelOpen) ? 'Fechar' : 'Chat entre agentes'
          }, [
            _cache[14] || (_cache[14] = _createElementVNode("svg", {
              width: "17",
              height: "17",
              viewBox: "0 0 24 24",
              fill: "none",
              stroke: "currentColor",
              "stroke-width": "2.2",
              "stroke-linecap": "round",
              "stroke-linejoin": "round"
            }, [
              _createElementVNode("path", { d: "M21 11.5a8.38 8.38 0 0 1-.9 3.8 8.5 8.5 0 0 1-7.6 4.7 8.38 8.38 0 0 1-3.8-.9L3 21l1.9-5.7a8.38 8.38 0 0 1-.9-3.8 8.5 8.5 0 0 1 4.7-7.6 8.38 8.38 0 0 1 3.8-.9h.5a8.48 8.48 0 0 1 8 8v.5z" })
            ], -1)),
            (_unref(totalUnread) > 0)
              ? (_openBlock(), _createElementBlock("span", _hoisted_2, _toDisplayString(_unref(totalUnread) > 9 ? '9+' : _unref(totalUnread)), 1))
              : _createCommentVNode("", true)
          ], 8, _hoisted_1),
          _createElementVNode("div", _hoisted_3, [
            (canScrollUp.value)
              ? (_openBlock(), _createElementBlock("button", {
                  key: 0,
                  class: "ach-scroll-btn up",
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (scrollList(-1))),
                  title: "Rolar para cima"
                }, [...(_cache[15] || (_cache[15] = [
                  _createElementVNode("svg", {
                    width: "12",
                    height: "12",
                    viewBox: "0 0 24 24",
                    fill: "none",
                    stroke: "currentColor",
                    "stroke-width": "3",
                    "stroke-linecap": "round",
                    "stroke-linejoin": "round"
                  }, [
                    _createElementVNode("polyline", { points: "18 15 12 9 6 15" })
                  ], -1)
                ]))]))
              : _createCommentVNode("", true),
            _createElementVNode("div", {
              class: "ach-av-list",
              ref_key: "avListEl",
              ref: avListEl,
              onScroll: updateScrollState
            }, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(agents), (a) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: a.id,
                  class: _normalizeClass(["ach-av-item", { active: _unref(activeAgentId) === a.id }]),
                  onClick: ($event: any) => (openAgent(a.id)),
                  onMouseenter: ($event: any) => (showAgentTT(a, $event)),
                  onMouseleave: hideAgentTT
                }, [
                  _createElementVNode("div", {
                    class: "ach-av",
                    style: _normalizeStyle({ background: _unref(avatarColor)(a.name) })
                  }, [
                    (a.avatarUrl)
                      ? (_openBlock(), _createElementBlock("img", {
                          key: 0,
                          src: a.avatarUrl,
                          alt: a.name,
                          onError: _cache[2] || (_cache[2] = (e) => (e.target as HTMLImageElement).style.display = 'none')
                        }, null, 40, _hoisted_5))
                      : (_openBlock(), _createElementBlock("span", _hoisted_6, _toDisplayString(_unref(initials)(a.name)), 1))
                  ], 4),
                  _createElementVNode("span", {
                    class: "ach-status-dot",
                    style: _normalizeStyle({ background: statusColor(a.availability) })
                  }, null, 4),
                  (_unref(unreadByAgent)[a.id])
                    ? (_openBlock(), _createElementBlock("span", _hoisted_7, _toDisplayString(_unref(unreadByAgent)[a.id] > 9 ? '9+' : _unref(unreadByAgent)[a.id]), 1))
                    : _createCommentVNode("", true)
                ], 42, _hoisted_4))
              }), 128)),
              (!_unref(agents).length && !_unref(loadingAgents))
                ? (_openBlock(), _createElementBlock("div", _hoisted_8, [...(_cache[16] || (_cache[16] = [
                    _createElementVNode("svg", {
                      width: "16",
                      height: "16",
                      viewBox: "0 0 24 24",
                      fill: "none",
                      stroke: "currentColor",
                      "stroke-width": "1.8",
                      "stroke-linecap": "round",
                      "stroke-linejoin": "round"
                    }, [
                      _createElementVNode("path", { d: "M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" }),
                      _createElementVNode("circle", {
                        cx: "12",
                        cy: "7",
                        r: "4"
                      })
                    ], -1)
                  ]))]))
                : _createCommentVNode("", true)
            ], 544),
            (canScrollDown.value)
              ? (_openBlock(), _createElementBlock("button", {
                  key: 1,
                  class: "ach-scroll-btn down",
                  onClick: _cache[3] || (_cache[3] = ($event: any) => (scrollList(1))),
                  title: "Rolar para baixo"
                }, [...(_cache[17] || (_cache[17] = [
                  _createElementVNode("svg", {
                    width: "12",
                    height: "12",
                    viewBox: "0 0 24 24",
                    fill: "none",
                    stroke: "currentColor",
                    "stroke-width": "3",
                    "stroke-linecap": "round",
                    "stroke-linejoin": "round"
                  }, [
                    _createElementVNode("polyline", { points: "6 9 12 15 18 9" })
                  ], -1)
                ]))]))
              : _createCommentVNode("", true)
          ]),
          (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
            _createVNode(_Transition, { name: "tt-pill" }, {
              default: _withCtx(() => [
                (ttAgent.value)
                  ? (_openBlock(), _createElementBlock("div", {
                      key: 0,
                      class: "ach-tt-card",
                      style: _normalizeStyle({ top: ttAgent.value.y + 'px', right: (STRIP_W + 8) + 'px' })
                    }, [
                      _createElementVNode("div", _hoisted_9, [
                        _createElementVNode("div", {
                          class: "ach-ttc-av",
                          style: _normalizeStyle({ background: _unref(avatarColor)(ttAgent.value.agent.name) })
                        }, [
                          (ttAgent.value.agent.avatarUrl)
                            ? (_openBlock(), _createElementBlock("img", {
                                key: 0,
                                src: ttAgent.value.agent.avatarUrl,
                                alt: ttAgent.value.agent.name,
                                onError: _cache[4] || (_cache[4] = (e) => (e.target as HTMLImageElement).style.display='none')
                              }, null, 40, _hoisted_10))
                            : (_openBlock(), _createElementBlock("span", _hoisted_11, _toDisplayString(_unref(initials)(ttAgent.value.agent.name)), 1)),
                          _createElementVNode("span", {
                            class: "ach-ttc-av-dot",
                            style: _normalizeStyle({ background: statusColor(ttAgent.value.agent.availability) })
                          }, null, 4)
                        ], 4),
                        _createElementVNode("div", _hoisted_12, [
                          _createElementVNode("div", _hoisted_13, [
                            _createElementVNode("span", _hoisted_14, _toDisplayString(ttAgent.value.agent.name), 1),
                            (_unref(unreadByAgent)[ttAgent.value.agent.id])
                              ? (_openBlock(), _createElementBlock("span", _hoisted_15, _toDisplayString(_unref(unreadByAgent)[ttAgent.value.agent.id] > 9 ? '9+' : _unref(unreadByAgent)[ttAgent.value.agent.id]), 1))
                              : _createCommentVNode("", true)
                          ]),
                          (ttAgent.value.agent.email)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_16, _toDisplayString(ttAgent.value.agent.email), 1))
                            : _createCommentVNode("", true)
                        ])
                      ]),
                      _cache[19] || (_cache[19] = _createElementVNode("div", { class: "ach-ttc-divider" }, null, -1)),
                      _createElementVNode("div", _hoisted_17, [
                        _createElementVNode("span", _hoisted_18, [
                          _createElementVNode("span", {
                            class: "ach-ttc-dot",
                            style: _normalizeStyle({ background: statusColor(ttAgent.value.agent.availability) })
                          }, null, 4),
                          _createTextVNode(" " + _toDisplayString(statusLabel(ttAgent.value.agent.availability)), 1)
                        ]),
                        (openCountFor(ttAgent.value.agent.id) > 0)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_19, [
                              _cache[18] || (_cache[18] = _createElementVNode("svg", {
                                width: "11",
                                height: "11",
                                viewBox: "0 0 24 24",
                                fill: "none",
                                stroke: "currentColor",
                                "stroke-width": "2.5",
                                "stroke-linecap": "round",
                                "stroke-linejoin": "round"
                              }, [
                                _createElementVNode("path", { d: "M3 18v-6a9 9 0 0 1 18 0v6" }),
                                _createElementVNode("path", { d: "M21 19a2 2 0 0 1-2 2h-1a2 2 0 0 1-2-2v-3a2 2 0 0 1 2-2h3zM3 19a2 2 0 0 0 2 2h1a2 2 0 0 0 2-2v-3a2 2 0 0 0-2-2H3z" })
                              ], -1)),
                              _createTextVNode(" Em atendimento · " + _toDisplayString(openCountFor(ttAgent.value.agent.id)), 1)
                            ]))
                          : (_openBlock(), _createElementBlock("span", _hoisted_20, "Livre no momento"))
                      ])
                    ], 4))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            })
          ])),
          _createElementVNode("div", {
            class: "ach-strip-footer",
            onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_unref(toggleRailMode) && _unref(toggleRailMode)(...args))),
            title: "Alternar para chat de clientes"
          }, [
            _cache[20] || (_cache[20] = _createStaticVNode("<svg width=\"16\" height=\"16\" viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2.2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" data-v-6d62a0c0><path d=\"M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2\" data-v-6d62a0c0></path><circle cx=\"12\" cy=\"7\" r=\"4\" data-v-6d62a0c0></circle><path d=\"M22 21v-2a4 4 0 0 0-3-3.87\" data-v-6d62a0c0></path><path d=\"M16 3.13a4 4 0 0 1 0 7.75\" data-v-6d62a0c0></path></svg>", 1)),
            (_unref(totalUnread) > 0)
              ? (_openBlock(), _createElementBlock("span", _hoisted_21, _toDisplayString(_unref(totalUnread) > 9 ? '9+' : _unref(totalUnread)), 1))
              : _createCommentVNode("", true)
          ])
        ], 2))
      : _createCommentVNode("", true),
    _createVNode(_Transition, { name: "ach-panel" }, {
      default: _withCtx(() => [
        (_unref(panelOpen) && _unref(railMode) === 'agent' && canUseAgentChat.value)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: "ach-panel",
              style: _normalizeStyle({ width: panelWidth.value + 'px' })
            }, [
              _createElementVNode("div", {
                class: "ach-resize-handle",
                onMousedown: _withModifiers(startResize, ["prevent"])
              }, null, 32),
              (_unref(activeAgentId) == null)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    _createElementVNode("div", _hoisted_22, [
                      _cache[23] || (_cache[23] = _createElementVNode("div", { class: "ach-head-title" }, [
                        _createElementVNode("svg", {
                          width: "13",
                          height: "13",
                          viewBox: "0 0 24 24",
                          fill: "none",
                          stroke: "currentColor",
                          "stroke-width": "2.5",
                          "stroke-linecap": "round",
                          "stroke-linejoin": "round"
                        }, [
                          _createElementVNode("path", { d: "M21 11.5a8.38 8.38 0 0 1-.9 3.8 8.5 8.5 0 0 1-7.6 4.7 8.38 8.38 0 0 1-3.8-.9L3 21l1.9-5.7a8.38 8.38 0 0 1-.9-3.8 8.5 8.5 0 0 1 4.7-7.6 8.38 8.38 0 0 1 3.8-.9h.5a8.48 8.48 0 0 1 8 8v.5z" })
                        ]),
                        _createTextVNode(" Chat entre agentes ")
                      ], -1)),
                      _createElementVNode("button", {
                        class: "ach-icon-btn",
                        onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_unref(closePanel) && _unref(closePanel)(...args)))
                      }, [...(_cache[22] || (_cache[22] = [
                        _createElementVNode("svg", {
                          width: "12",
                          height: "12",
                          viewBox: "0 0 24 24",
                          fill: "none",
                          stroke: "currentColor",
                          "stroke-width": "3",
                          "stroke-linecap": "round",
                          "stroke-linejoin": "round"
                        }, [
                          _createElementVNode("line", {
                            x1: "18",
                            y1: "6",
                            x2: "6",
                            y2: "18"
                          }),
                          _createElementVNode("line", {
                            x1: "6",
                            y1: "6",
                            x2: "18",
                            y2: "18"
                          })
                        ], -1)
                      ]))])
                    ]),
                    (_unref(agents).length)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
                          _cache[25] || (_cache[25] = _createElementVNode("svg", {
                            width: "14",
                            height: "14",
                            viewBox: "0 0 24 24",
                            fill: "none",
                            stroke: "currentColor",
                            "stroke-width": "2.2",
                            "stroke-linecap": "round",
                            "stroke-linejoin": "round"
                          }, [
                            _createElementVNode("circle", {
                              cx: "11",
                              cy: "11",
                              r: "8"
                            }),
                            _createElementVNode("line", {
                              x1: "21",
                              y1: "21",
                              x2: "16.65",
                              y2: "16.65"
                            })
                          ], -1)),
                          _withDirectives(_createElementVNode("input", {
                            "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((agentSearch).value = $event)),
                            type: "text",
                            class: "ach-search-input",
                            placeholder: "Buscar agente…"
                          }, null, 512), [
                            [_vModelText, agentSearch.value]
                          ]),
                          (agentSearch.value)
                            ? (_openBlock(), _createElementBlock("button", {
                                key: 0,
                                class: "ach-search-clear",
                                onClick: _cache[8] || (_cache[8] = ($event: any) => (agentSearch.value = '')),
                                title: "Limpar busca"
                              }, [...(_cache[24] || (_cache[24] = [
                                _createElementVNode("svg", {
                                  width: "11",
                                  height: "11",
                                  viewBox: "0 0 24 24",
                                  fill: "none",
                                  stroke: "currentColor",
                                  "stroke-width": "3",
                                  "stroke-linecap": "round",
                                  "stroke-linejoin": "round"
                                }, [
                                  _createElementVNode("line", {
                                    x1: "18",
                                    y1: "6",
                                    x2: "6",
                                    y2: "18"
                                  }),
                                  _createElementVNode("line", {
                                    x1: "6",
                                    y1: "6",
                                    x2: "18",
                                    y2: "18"
                                  })
                                ], -1)
                              ]))]))
                            : _createCommentVNode("", true)
                        ]))
                      : _createCommentVNode("", true),
                    (_unref(loadingAgents))
                      ? (_openBlock(), _createElementBlock("div", _hoisted_24, "Carregando agentes…"))
                      : (!_unref(agents).length)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_25, [...(_cache[26] || (_cache[26] = [
                            _createElementVNode("svg", {
                              width: "36",
                              height: "36",
                              viewBox: "0 0 24 24",
                              fill: "none",
                              stroke: "currentColor",
                              "stroke-width": "1.3",
                              "stroke-linecap": "round",
                              "stroke-linejoin": "round"
                            }, [
                              _createElementVNode("path", { d: "M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" }),
                              _createElementVNode("circle", {
                                cx: "12",
                                cy: "7",
                                r: "4"
                              })
                            ], -1),
                            _createElementVNode("p", null, "Nenhum outro agente encontrado", -1)
                          ]))]))
                        : (!filteredAgents.value.length)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
                              _cache[27] || (_cache[27] = _createElementVNode("svg", {
                                width: "36",
                                height: "36",
                                viewBox: "0 0 24 24",
                                fill: "none",
                                stroke: "currentColor",
                                "stroke-width": "1.3",
                                "stroke-linecap": "round",
                                "stroke-linejoin": "round"
                              }, [
                                _createElementVNode("circle", {
                                  cx: "11",
                                  cy: "11",
                                  r: "8"
                                }),
                                _createElementVNode("line", {
                                  x1: "21",
                                  y1: "21",
                                  x2: "16.65",
                                  y2: "16.65"
                                })
                              ], -1)),
                              _createElementVNode("p", null, "Nenhum agente encontrado para \"" + _toDisplayString(agentSearch.value) + "\"", 1)
                            ]))
                          : (_openBlock(), _createElementBlock("div", _hoisted_27, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(filteredAgents.value, (a) => {
                                return (_openBlock(), _createElementBlock("div", {
                                  key: a.id,
                                  class: "ach-item",
                                  onClick: ($event: any) => (openAgent(a.id))
                                }, [
                                  _createElementVNode("div", _hoisted_29, [
                                    _createElementVNode("div", {
                                      class: "ach-item-av",
                                      style: _normalizeStyle({ background: _unref(avatarColor)(a.name) })
                                    }, [
                                      (a.avatarUrl)
                                        ? (_openBlock(), _createElementBlock("img", {
                                            key: 0,
                                            src: a.avatarUrl,
                                            alt: a.name,
                                            onError: _cache[9] || (_cache[9] = (e) => (e.target as HTMLImageElement).style.display = 'none')
                                          }, null, 40, _hoisted_30))
                                        : (_openBlock(), _createElementBlock("span", _hoisted_31, _toDisplayString(_unref(initials)(a.name)), 1))
                                    ], 4),
                                    _createElementVNode("span", {
                                      class: "ach-status-dot sm",
                                      style: _normalizeStyle({ background: statusColor(a.availability) })
                                    }, null, 4)
                                  ]),
                                  _createElementVNode("div", _hoisted_32, [
                                    _createElementVNode("span", _hoisted_33, _toDisplayString(a.name), 1),
                                    _createElementVNode("span", _hoisted_34, _toDisplayString(statusLabel(a.availability)), 1)
                                  ]),
                                  (_unref(unreadByAgent)[a.id])
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_35, _toDisplayString(_unref(unreadByAgent)[a.id] > 9 ? '9+' : _unref(unreadByAgent)[a.id]), 1))
                                    : _createCommentVNode("", true)
                                ], 8, _hoisted_28))
                              }), 128))
                            ]))
                  ], 64))
                : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                    _createElementVNode("div", _hoisted_36, [
                      _createElementVNode("button", {
                        class: "ach-icon-btn",
                        onClick: _cache[10] || (_cache[10] = 
//@ts-ignore
(...args) => (_unref(backToList) && _unref(backToList)(...args))),
                        title: "Voltar"
                      }, [...(_cache[28] || (_cache[28] = [
                        _createElementVNode("svg", {
                          width: "13",
                          height: "13",
                          viewBox: "0 0 24 24",
                          fill: "none",
                          stroke: "currentColor",
                          "stroke-width": "3",
                          "stroke-linecap": "round",
                          "stroke-linejoin": "round"
                        }, [
                          _createElementVNode("polyline", { points: "15 18 9 12 15 6" })
                        ], -1)
                      ]))]),
                      (_unref(activeAgent))
                        ? (_openBlock(), _createElementBlock("div", _hoisted_37, [
                            _createElementVNode("div", {
                              class: "ach-chat-hav",
                              style: _normalizeStyle({ background: _unref(avatarColor)(_unref(activeAgent).name) })
                            }, [
                              (_unref(activeAgent).avatarUrl)
                                ? (_openBlock(), _createElementBlock("img", {
                                    key: 0,
                                    src: _unref(activeAgent).avatarUrl,
                                    alt: _unref(activeAgent).name,
                                    onError: _cache[11] || (_cache[11] = (e) => (e.target as HTMLImageElement).style.display = 'none')
                                  }, null, 40, _hoisted_38))
                                : (_openBlock(), _createElementBlock("span", _hoisted_39, _toDisplayString(_unref(initials)(_unref(activeAgent).name)), 1))
                            ], 4),
                            _createElementVNode("div", _hoisted_40, [
                              _createElementVNode("div", _hoisted_41, _toDisplayString(_unref(activeAgent).name), 1),
                              _createElementVNode("div", _hoisted_42, [
                                _createElementVNode("span", {
                                  class: "ach-status-dot sm",
                                  style: _normalizeStyle({ background: statusColor(_unref(activeAgent).availability) })
                                }, null, 4),
                                _createTextVNode(" " + _toDisplayString(statusLabel(_unref(activeAgent).availability)), 1)
                              ])
                            ])
                          ]))
                        : _createCommentVNode("", true),
                      _createElementVNode("button", {
                        class: "ach-icon-btn",
                        onClick: _cache[12] || (_cache[12] = 
//@ts-ignore
(...args) => (_unref(closePanel) && _unref(closePanel)(...args)))
                      }, [...(_cache[29] || (_cache[29] = [
                        _createElementVNode("svg", {
                          width: "12",
                          height: "12",
                          viewBox: "0 0 24 24",
                          fill: "none",
                          stroke: "currentColor",
                          "stroke-width": "3",
                          "stroke-linecap": "round",
                          "stroke-linejoin": "round"
                        }, [
                          _createElementVNode("line", {
                            x1: "18",
                            y1: "6",
                            x2: "6",
                            y2: "18"
                          }),
                          _createElementVNode("line", {
                            x1: "6",
                            y1: "6",
                            x2: "18",
                            y2: "18"
                          })
                        ], -1)
                      ]))])
                    ]),
                    _createElementVNode("div", {
                      class: "ach-messages",
                      ref_key: "msgListEl",
                      ref: msgListEl
                    }, [
                      (_unref(loadingMessages))
                        ? (_openBlock(), _createElementBlock("div", _hoisted_43, "Carregando…"))
                        : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                            (!_unref(activeMessages).length)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_44, [...(_cache[30] || (_cache[30] = [
                                  _createElementVNode("p", null, "Nenhuma mensagem ainda — diga olá!", -1)
                                ]))]))
                              : _createCommentVNode("", true),
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(activeMessages), (m) => {
                              return (_openBlock(), _createElementBlock("div", {
                                key: m.id,
                                class: _normalizeClass(["ach-msg-row", m.senderId === myId.value ? 'out' : 'inn'])
                              }, [
                                _createElementVNode("div", _hoisted_45, [
                                  _createElementVNode("span", _hoisted_46, _toDisplayString(m.body), 1),
                                  _createElementVNode("span", _hoisted_47, _toDisplayString(fmtTs(m.createdAt)), 1)
                                ])
                              ], 2))
                            }), 128))
                          ], 64))
                    ], 512),
                    (_unref(sendError))
                      ? (_openBlock(), _createElementBlock("div", _hoisted_48, _toDisplayString(_unref(sendError)), 1))
                      : _createCommentVNode("", true),
                    _createElementVNode("form", {
                      class: "ach-input-row",
                      onSubmit: _withModifiers(onSend, ["prevent"])
                    }, [
                      _withDirectives(_createElementVNode("input", {
                        "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((draft).value = $event)),
                        class: "ach-input",
                        placeholder: "Mensagem… (Enter envia)",
                        disabled: sending.value
                      }, null, 8, _hoisted_49), [
                        [_vModelText, draft.value]
                      ]),
                      _createElementVNode("button", {
                        type: "submit",
                        class: "ach-send-btn",
                        disabled: !draft.value.trim() || sending.value
                      }, [...(_cache[31] || (_cache[31] = [
                        _createElementVNode("svg", {
                          width: "16",
                          height: "16",
                          viewBox: "0 0 24 24",
                          fill: "none",
                          stroke: "currentColor",
                          "stroke-width": "2.2",
                          "stroke-linecap": "round",
                          "stroke-linejoin": "round"
                        }, [
                          _createElementVNode("line", {
                            x1: "22",
                            y1: "2",
                            x2: "11",
                            y2: "13"
                          }),
                          _createElementVNode("polygon", { points: "22 2 15 22 11 13 2 9 22 2" })
                        ], -1)
                      ]))], 8, _hoisted_50)
                    ], 32)
                  ], 64))
            ], 4))
          : _createCommentVNode("", true)
      ]),
      _: 1
    })
  ], 64))
}
}

})